import React from 'react';
import WingBlank from '../../components/WingBlank';
import './Copyright.less';

function Copyright({year, company, icp}) {
  return (
    <WingBlank className='AppCopyright'>
      <span>{`版权所有(C)${year} ${company}`}</span>
      <a href='http://beian.miit.gov.cn' target='_blank' rel='noopener noreferrer'>
        {icp}
      </a>

      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030802000650" rel='noopener noreferrer'>
        <img src="/imgs/batb.png" />{'粤公网安备 44030802000650号'}
      </a>
    </WingBlank>
  );
}

export default Copyright;


// WEBPACK FOOTER //
// ./src/routes/App/Copyright.js